import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom';
import qs from 'qs';
import buscarFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/buscarFechamentoCaixa';
import { arredondamentoPadrao, formatarReal, realParaNumber } from '../../../util/numberUtil';

const PRINT_STYLES = `
  @media print {
    @page {
      margin: 0;
      size: A4 portrait;
    }

    body {
      margin: 0 !important;
      padding: 0 !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    /* Esconde sidebar, overlay e header */
    .vx-sidebar,
    .vx-sidebar-overlay,
    .vx-content-wrapper > div:first-child,
    #printPageButton {
      display: none !important;
    }

    /* Remove padding do shell (sidebar) */
    .vx-shell {
      padding-left: 0 !important;
    }

    /* Zera margens do conteúdo */
    .vx-main,
    .vx-content-wrapper,
    .container-fluid,
    .animated,
    .fadeIn {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    .grid.invoice {
      margin: 0 !important;
      padding: 5mm 6mm !important;
      border: none !important;
      box-shadow: none !important;
    }

    /* Grid de duas colunas no print */
    .fc-totais-row {
      display: flex !important;
      flex-wrap: nowrap !important;
      gap: 0 !important;
      margin: 0 !important;
    }

    .fc-totais-col {
      width: 50% !important;
      padding: 0 2mm !important;
      box-sizing: border-box !important;
    }

    /* Tabelas */
    table {
      font-size: 7.5pt !important;
      width: 100% !important;
      border-collapse: collapse !important;
      page-break-inside: auto !important;
    }

    thead { display: table-header-group !important; }
    tfoot { display: table-footer-group !important; }
    tr { page-break-inside: avoid !important; }

    th, td {
      padding: 2px 3px !important;
      font-size: 7.5pt !important;
    }

    h1.fc-titulo {
      font-size: 13pt !important;
      margin: 0 0 4mm 0 !important;
      text-align: center !important;
    }

    .fc-header {
      font-size: 8pt !important;
      margin-bottom: 3mm !important;
    }

    .fc-header strong {
      font-size: 8pt !important;
    }

    .fc-assinatura {
      margin-top: 10mm !important;
    }

    .fc-table-wrap {
      overflow: visible !important;
    }

    .fc-section {
      margin-top: 3mm !important;
    }
  }
`;

export class PainelDetalhamentoFechamentoCaixa extends React.Component {
  constructor (props) {
    super(props);
    this.componentRef = React.createRef();
  }

  imprimir () {
    window.print();
  }

  componentDidMount () {
    if (this.props.empresaSelecionada.id) {
      const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
      if (parametros.usuarioEmpresa && parametros.data) {
        this.props.buscarFechamentoCaixa(this.props.empresaSelecionada.id, parametros.usuarioEmpresa, parametros.data, parametros.fechamento);
      }
    } else {
      this.props.history.push('/painel-fechamento-caixa')
    }
  }

  exbirLinhaTotal (titulo, valor) {
    return (
      <tr key={titulo}>
        <td style={{ fontSize: '0.78rem', padding: '3px 6px' }}>{titulo}</td>
        <td style={{ fontSize: '0.78rem', padding: '3px 6px', textAlign: 'right', whiteSpace: 'nowrap' }}>
          {arredondamentoPadrao(realParaNumber(valor)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        </td>
      </tr>
    );
  }

  exibirHistoricos () {
    if (this.props.fechamentoCaixa.historicos && this.props.fechamentoCaixa.historicos.length) {
      return (
        <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
          <table className="table table-sm table-striped table-bordered text-center">
            <thead className="thead-light">
              <tr>
                <td colSpan={4}><strong>Movimentações do caixa</strong></td>
              </tr>
              <tr>
                <th scope="col">Data e Hora</th>
                <th scope="col">Situação</th>
                <th scope="col">Usuário</th>
                <th scope="col">Observação</th>
              </tr>
            </thead>
            <tbody>
              {this.props.fechamentoCaixa.historicos.map(historico => (
                <tr key={`historico-${historico.dataHora}`}>
                  <td>{historico.dataHora}</td>
                  <td>{historico.descricaoSituacao}</td>
                  <td>{historico.nomeUsuario}</td>
                  <td>{historico.observacao}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }

  calcularTotalValorEncomenda (encomendas) {
    let valor = 0;
    encomendas.forEach(encomenda => {
      encomenda.encomendas.forEach(encomenda2 => {
        if (encomenda.situacao === 'Cancelado') {
          valor = valor - realParaNumber(encomenda2.valor)
        } else {
          valor = valor + realParaNumber(encomenda2.valor)
        }
      })
    })
    return formatarReal(valor.toString())
  }

  calcularTotalValorReservas (reservas) {
    let valor = 0;
    reservas.forEach(reserva => {
      reserva.reservas.forEach(reserva2 => {
        if (reserva.situacao === 'Cancelado' || reserva.situacao === 'Cancelado/Reembolso Efetuado') {
          valor = valor - realParaNumber(reserva2.valorTotalReserva)
        } else {
          if (reserva2.seRemarcacao) {
            valor = valor + realParaNumber(reserva2.custoRemarcacao)
          } else {
            valor = valor + realParaNumber(reserva2.valorTotalReserva)
          }
        }
      })
    })
    return formatarReal(valor.toString())
  }

  exibirEncomendas () {
    if (this.props.fechamentoCaixa.detalhamento) {
      const encomendas = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'ENCOMENDA');
      if (encomendas.length) {
        return (
          <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="table table-sm table-striped table-bordered text-center">
              <thead className="thead-light">
                <tr>
                  <td colSpan={8}><strong>Encomendas</strong></td>
                </tr>
                <tr>
                  <th scope="col">Pedido</th>
                  <th scope="col">Remetente</th>
                  <th scope="col">Situação</th>
                  <th scope="col">Pagamento</th>
                  <th scope="col">VL Imposto</th>
                  <th scope="col">VL Comissão</th>
                  <th scope="col">VL Pedágio</th>
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                {encomendas.map(encomenda =>
                  encomenda.encomendas.map(encomenda2 => (
                    <tr key={`encomenda-${encomenda2.id}`}>
                      <td>{encomenda2.idPedido}</td>
                      <td>{encomenda2.remetente.nome}</td>
                      <td>{encomenda.situacao}</td>
                      <td>{encomenda2.descricaoFormasPagamento}</td>
                      <td>{encomenda.situacao === 'Cancelado' ? '-' : <span>{formatarReal(encomenda2.impostoRetido)}</span>}</td>
                      <td>{encomenda.situacao === 'Cancelado' ? '-' : <span>{formatarReal(encomenda2.comissao)}</span>}</td>
                      <td>{encomenda.situacao === 'Cancelado' ? '-' : <span>{formatarReal(encomenda2.pedagio)}</span>}</td>
                      <td>{encomenda.situacao === 'Cancelado' ? '-' : <span>{formatarReal(encomenda2.valor)}</span>}</td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={4}><strong>TOTAL EM ENCOMENDAS</strong></td>
                  <td><span>{formatarReal(this.props.fechamentoCaixa.totais.totalImpostoRetidoEncomendas)}</span></td>
                  <td>{formatarReal(this.props.fechamentoCaixa.totais.totalComissaoEncomendas)}</td>
                  <td>{formatarReal(this.props.fechamentoCaixa.totais.totalPedagio)}</td>
                  <td>{this.calcularTotalValorEncomenda(encomendas).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        );
      }
    }
  }

  // valor de venda urbana/encomenda avulsa vem como BigDecimal.toString() (ponto decimal, ex.: "1000.00")
  calcularTotalValorPedidosSimples (detalhamentos, campoLista) {
    let valor = 0;
    detalhamentos.forEach(detalhamento => {
      detalhamento[campoLista].forEach(item => {
        valor = detalhamento.situacao === 'Cancelado' ? valor - Number(item.valor) : valor + Number(item.valor)
      })
    })
    return formatarReal(valor.toFixed(2))
  }

  exibirVendasUrbanas () {
    if (this.props.fechamentoCaixa.detalhamento) {
      const vendasUrbanas = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'VENDA_URBANA' && f.vendasUrbanas && f.vendasUrbanas.length);
      if (vendasUrbanas.length) {
        return (
          <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="table table-sm table-striped table-bordered text-center">
              <thead className="thead-light">
                <tr>
                  <td colSpan={6}><strong>Vendas Urbanas</strong></td>
                </tr>
                <tr>
                  <th scope="col">Pedido</th>
                  <th scope="col">Passageiro</th>
                  <th scope="col">Situação</th>
                  <th scope="col">Origem / Destino</th>
                  <th scope="col">Pagamento</th>
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                {vendasUrbanas.map(detalhamento =>
                  detalhamento.vendasUrbanas.map(venda => (
                    <tr key={`venda-urbana-${detalhamento.situacao}-${venda.id}`}>
                      <td>{venda.idPedido}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{venda.nomePassageiro}</td>
                      <td>{detalhamento.situacao}</td>
                      <td>{venda.cidadeOrigem} / {venda.cidadeDestino}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{venda.descricaoFormaPagamento}</td>
                      <td>{this.exibirSinalSubtracao(detalhamento.situacao, venda.valor.replace('.', ','))}{formatarReal(venda.valor)}</td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5}><strong>TOTAL EM VENDAS URBANAS</strong></td>
                  <td>{this.calcularTotalValorPedidosSimples(vendasUrbanas, 'vendasUrbanas')}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        );
      }
    }
  }

  exibirEncomendasAvulsas () {
    if (this.props.fechamentoCaixa.detalhamento) {
      const encomendasAvulsas = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'ENCOMENDA_AVULSA' && f.encomendasAvulsas && f.encomendasAvulsas.length);
      if (encomendasAvulsas.length) {
        return (
          <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="table table-sm table-striped table-bordered text-center">
              <thead className="thead-light">
                <tr>
                  <td colSpan={7}><strong>Encomendas Avulsas</strong></td>
                </tr>
                <tr>
                  <th scope="col">Pedido</th>
                  <th scope="col">Remetente</th>
                  <th scope="col">Destinatário</th>
                  <th scope="col">Situação</th>
                  <th scope="col">Pagamento</th>
                  <th scope="col">Volumes</th>
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                {encomendasAvulsas.map(detalhamento =>
                  detalhamento.encomendasAvulsas.map(encomenda => (
                    <tr key={`encomenda-avulsa-${detalhamento.situacao}-${encomenda.id}`}>
                      <td>{encomenda.numeroPedido}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{encomenda.nomeRemetente}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{encomenda.nomeDestinatario}</td>
                      <td>{detalhamento.situacao}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{encomenda.descricaoFormaPagamento}</td>
                      <td>{encomenda.volumes}</td>
                      <td>{this.exibirSinalSubtracao(detalhamento.situacao, encomenda.valor.replace('.', ','))}{formatarReal(encomenda.valor)}</td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={6}><strong>TOTAL EM ENCOMENDAS AVULSAS</strong></td>
                  <td>{this.calcularTotalValorPedidosSimples(encomendasAvulsas, 'encomendasAvulsas')}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        );
      }
    }
  }

  exibirComissaoEntrega () {
    if (this.props.fechamentoCaixa.detalhamento) {
      const entregas = this.props.fechamentoCaixa.detalhamento.filter(f => f.encomendasEntrega && f.encomendasEntrega.length);
      if (entregas.length) {
        return (
          <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="table table-sm table-striped table-bordered text-center">
              <thead className="thead-light">
                <tr>
                  <td colSpan={5}><strong>Comissão de Entrega de Encomenda</strong></td>
                </tr>
                <tr>
                  <th scope="col">Pedido</th>
                  <th scope="col">Destinatário</th>
                  <th scope="col">Responsável pela Entrega</th>
                  <th scope="col">% Comissão</th>
                  <th scope="col">VL Comissão</th>
                </tr>
              </thead>
              <tbody>
                {entregas.map(entrega =>
                  entrega.encomendasEntrega.map(encomenda2 => (
                    <tr key={`entrega-${encomenda2.id}`}>
                      <td>{encomenda2.idPedido}</td>
                      <td>{encomenda2.destinatario.nome}</td>
                      <td>{encomenda2.nomeUsuarioEntrega}</td>
                      <td>{encomenda2.percentualComissaoEntrega}%</td>
                      <td>{formatarReal(encomenda2.comissaoEntrega)}</td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={4}><strong>TOTAL COMISSÃO DE ENTREGA</strong></td>
                  <td>{formatarReal(this.props.fechamentoCaixa.totais.totalComissaoEntrega)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        );
      }
    }
  }

  exibirBagagens () {
    if (this.props.fechamentoCaixa.detalhamento) {
      const detalhamentos = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'BAGAGEM');
      if (detalhamentos.length) {
        return (
          <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="table table-sm table-striped table-bordered text-center">
              <thead className="thead-light">
                <tr>
                  <td colSpan={8}><strong>Bagagens</strong></td>
                </tr>
                <tr>
                  <th scope="col">Reserva</th>
                  <th scope="col">Passageiro</th>
                  <th scope="col">Situação</th>
                  <th scope="col">Rastreio</th>
                  <th scope="col">VL Imposto</th>
                  <th scope="col">VL Comissão</th>
                  <th scope="col">Peso KG</th>
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                {detalhamentos.map(detalhamento =>
                  detalhamento.bagagens.map(bagagem => (
                    <tr key={`bagagem-${bagagem.id}`}>
                      <td>{bagagem.reservaId}</td>
                      <td>{bagagem.nomePassageiro}</td>
                      <td>{detalhamento.situacao}</td>
                      <td>{bagagem.codigoRastreio}</td>
                      <td>
                        {detalhamento.situacao === 'Cancelado' ? '-' :
                          <span>{'R$ ' + bagagem.impostoRetido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>}
                      </td>
                      <td>
                        {detalhamento.situacao === 'Cancelado' ? '-' :
                          <span>{'R$ ' + bagagem.comissao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>}
                      </td>
                      <td>
                        {detalhamento.situacao === 'Cancelado' ? '-' :
                          <span>{'kg ' + bagagem.peso.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>}
                      </td>
                      <td>
                        {detalhamento.situacao === 'Cancelado' ? '-' :
                          <span>{'R$ ' + bagagem.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={4}><strong>TOTAL EM BAGAGENS</strong></td>
                  <td><span>{formatarReal(this.props.fechamentoCaixa.totais.totalImpostoRetidoBagagens)}</span></td>
                  <td>{formatarReal(this.props.fechamentoCaixa.totais.totalComissaoBagagens)}</td>
                  <td>-</td>
                  <td>{this.props.fechamentoCaixa.totais.totalEmBagagensAprovadas.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        );
      }
    }
  }

  exibirValorNegativoComissao (valor) {
    return valor > 0 ? <span>-{formatarReal(valor)}</span> : <span>R$0.00</span>
  }

  // subtrai o estorno de um valor base (comissaoSeguro), tratando string
  // "0,00"/"0.00" e undefined/null como zero
  subtrairValor (valor, estorno) {
    const numValor = valor ? Number(valor.toString().replace(',', '.')) : 0;
    const numEstorno = estorno ? Number(estorno.toString().replace(',', '.')) : 0;
    return arredondamentoPadrao(numValor - numEstorno).toString();
  }

  // Comissão de seguro exibida na linha Aprovado: se a MESMA reserva também
  // aparece cancelada nesta tabela (cancelamento total no mesmo dia), o
  // estorno já é mostrado na linha "Cancelado" -- aqui mantém o valor bruto
  // original, sem netar, senão a soma das duas linhas não bateria com o
  // rodapé "TOTAL EM RESERVAS". Só neta o estorno aqui quando NÃO existe
  // linha Cancelado para essa reserva (caso do cancelamento avulso do
  // seguro, que não muda a situação da reserva -- SeguroService.cancelarSeguro)
  comissaoSeguroAprovada (reservas, reservaCorrente) {
    const existeLinhaCancelada = reservas.some(r =>
      ['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(r.situacao) &&
      r.reservas.some(r2 => r2.id === reservaCorrente.id)
    );
    return existeLinhaCancelada
      ? reservaCorrente.comissaoSeguro
      : this.subtrairValor(reservaCorrente.comissaoSeguro, reservaCorrente.estornoComissaoSeguro);
  }

  exibirValorNegativoImposto (valor) {
    return valor > 0 ? <span>-{formatarReal(valor)}</span> : <span>R$0.00</span>
  }

  exibirValorImpostoRetidoAprovadas (reservas, reservaCorrente) {
    let valor = formatarReal(reservaCorrente.impostoRetido);
    reservas.filter(f => f.situacao === 'Cancelado').forEach(reserva => {
      reserva.reservas.forEach(reserva2 => {
        if (reserva2.id === reservaCorrente.id &&
          reservaCorrente.idRemarcada !== null &&
          reservaCorrente.custoRemarcacao === null) {
          valor = 'R$0,00';
        }
      })
    })
    return valor;
  }

  exibirSinalSubtracao (situacao, valor) {
    if (['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(situacao) && realParaNumber(valor) > 0) {
      return ' -';
    }
  }

  exbibirReservas (situacoes, titulo, exibirRodape) {
    if (this.props.fechamentoCaixa.detalhamento) {
      const reservas = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'PASSAGEM' && situacoes.includes(f.situacao));
      if (reservas.length) {
        const temCancelado = situacoes.includes('Cancelado') || situacoes.includes('Cancelado/Reembolso Efetuado');
        return (
          <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="table table-sm table-striped table-bordered text-center">
              <thead className="thead-light">
                <tr>
                  <td colSpan={temCancelado ? 13 : 12}><strong>{titulo}</strong></td>
                </tr>
                <tr>
                  <th scope="col">Pedido</th>
                  <th scope="col">Passageiro</th>
                  <th scope="col">Situação</th>
                  <th scope="col">Poltrona</th>
                  <th scope="col">Pagamento</th>
                  <th scope="col">Imposto</th>
                  <th scope="col">Comissão</th>
                  <th scope="col">Comissão Seguro</th>
                  <th scope="col">Pedágio</th>
                  <th scope="col">Embarque</th>
                  <th scope="col">Seguro</th>
                  {temCancelado ? <th scope="col">Vl. Estorno</th> : null}
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                {reservas.map(reserva =>
                  reserva.reservas.map(reserva2 => (
                    <tr key={`reserva-${reserva2.id}`}>
                      <td>{reserva2.pedidoId}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{reserva2.passageiroDto.nome}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{reserva.situacao}</td>
                      <td>{reserva2.numeroPoltrona}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{reserva2.descricaoFormasPagamento}</td>
                      <td>
                        {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(reserva.situacao)
                          ? this.exibirValorNegativoImposto(reserva2.estornoImpostoRetido)
                          : <span>{this.exibirValorImpostoRetidoAprovadas(reservas, reserva2)}</span>}
                      </td>
                      <td>
                        {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(reserva.situacao)
                          ? this.exibirValorNegativoComissao(reserva2.estornoComissao)
                          : <span>{formatarReal(reserva2.comissao)}</span>}
                      </td>
                      <td>
                        {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(reserva.situacao)
                          ? this.exibirValorNegativoComissao(reserva2.estornoComissaoSeguro)
                          : <span>{formatarReal(this.comissaoSeguroAprovada(reservas, reserva2))}</span>}
                      </td>
                      <td>
                        {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(reserva.situacao)
                          ? this.exibirValorNegativoComissao(reserva2.pedagio)
                          : <span>{formatarReal(reserva2.pedagio)}</span>}
                      </td>
                      <td>
                        {['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(reserva.situacao)
                          ? this.exibirValorNegativoComissao(reserva2.taxaEmbarque)
                          : <span>{reserva2.taxaEmbarque}</span>}
                      </td>
                      <td>
                        {reserva2.temEstornoSeguro
                          ? this.exibirValorNegativoComissao(reserva2.tarifaSeguro)
                          : <span>{reserva2.tarifaSeguro}</span>}
                      </td>
                      {temCancelado
                        ? <td><span>{['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(reserva.situacao) ? formatarReal(reserva2.valorEstorno) : '-'}</span></td>
                        : null}
                      <td>
                        {reserva2.seRemarcacao && !['Cancelado', 'Cancelado/Reembolso Efetuado'].includes(reserva.situacao)
                          ? <span>{this.exibirSinalSubtracao(reserva.situacao, reserva2.custoRemarcacao)}{formatarReal(reserva2.custoRemarcacao)}</span>
                          : <span>{this.exibirSinalSubtracao(reserva.situacao, reserva2.valor)}{formatarReal(reserva2.valor)}</span>}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              {exibirRodape
                ? <tfoot>
                    <tr>
                      <td colSpan={temCancelado ? 5 : 4}><strong>TOTAL EM RESERVAS</strong></td>
                      <td><span>{formatarReal(this.props.fechamentoCaixa.totais.totalImpostoRetidoReservas)}</span></td>
                      <td>{formatarReal(this.props.fechamentoCaixa.totais.totalComissaoReservas)}</td>
                      <td>{formatarReal(this.props.fechamentoCaixa.totais.totalComissaoSeguro)}</td>
                      <td>{formatarReal(this.props.fechamentoCaixa.totais.totalPedagio)}</td>
                      <td></td>
                      <td>{formatarReal(this.props.fechamentoCaixa.totais.totalTarifaSeguro)}</td>
                      {temCancelado ? <td></td> : null}
                      <td>{formatarReal(this.props.fechamentoCaixa.totais.totalEmReservas)}</td>
                    </tr>
                  </tfoot>
                : null}
            </table>
          </div>
        );
      }
    }
  }

  exbibirEstornos (titulo) {
    if (this.props.fechamentoCaixa.detalhamento) {
      const detalhamentos = this.props.fechamentoCaixa.detalhamento.filter(f => f.tipo === 'PASSAGEM' && 'Seguro Cancelado'.includes(f.situacao));
      if (detalhamentos && detalhamentos.length) {
        return (
          <div className="fc-section fc-table-wrap" style={{ overflowX: 'auto' }}>
            <table className="table table-sm table-striped table-bordered text-center">
              <thead className="thead-light">
                <tr>
                  <td colSpan={6}><strong>{titulo}</strong></td>
                </tr>
                <tr>
                  <th scope="col">Pedido</th>
                  <th scope="col">Reserva</th>
                  <th scope="col">Passageiro</th>
                  <th scope="col">Situação</th>
                  <th scope="col">Poltrona</th>
                  <th scope="col">Valor</th>
                </tr>
              </thead>
              <tbody>
                {detalhamentos.map(detalhamento =>
                  detalhamento.estornos
                    ? detalhamento.estornos.map(estorno => (
                        <tr key={`estorno-${estorno.id}`}>
                          <td>{estorno.idPedido}</td>
                          <td>{estorno.idReserva}</td>
                          <td>{estorno.nomePassageiro}</td>
                          <td>Cancelado</td>
                          <td>{estorno.poltrona}</td>
                          <td>{this.exibirValorNegativoComissao(estorno.valor)}</td>
                        </tr>
                      ))
                    : ''
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5}><strong>TOTAL EM RESERVAS</strong></td>
                  <td>-R${this.props.fechamentoCaixa.totais.totalCancelamentoSeguro}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        );
      }
    }
  }

  exibir () {
    const { fechamentoCaixa, empresaSelecionada } = this.props;
    return (
      <React.Fragment>
        {/* Cabeçalho */}
        <div className="fc-header" style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '4px',
          marginBottom: '12px',
          fontSize: '0.85rem'
        }}>
          <strong style={{ flex: '1 1 auto' }}>{empresaSelecionada.nome}</strong>
          <span style={{ flex: '1 1 auto', textAlign: 'center' }}>Vendedor: <strong>{fechamentoCaixa.nomeUsuario}</strong></span>
          <span style={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}>Data: <strong>{fechamentoCaixa.dataFechamento}</strong></span>
        </div>
        <hr style={{ margin: '0 0 10px 0' }} />

        {/* Totais — duas colunas */}
        <div className="fc-totais-row" style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '0',
          marginBottom: '8px'
        }}>
          <div className="fc-totais-col" style={{ flex: '1 1 280px', overflowX: 'auto' }}>
            <table className="table table-sm table-bordered" style={{ marginBottom: 0 }}>
              <tbody>
                {this.exbirLinhaTotal('(+) Total Tx de Serviço', fechamentoCaixa.totais.totalTaxaServico)}
                {this.exbirLinhaTotal('(+) Total Tx de Pedágio', fechamentoCaixa.totais.totalPedagio)}
                {this.exbirLinhaTotal('(+) Total adiantamento baixado', fechamentoCaixa.totais.totalAdiantamentoBaixado)}
                {this.exbirLinhaTotal('(-) Total adiantamento lançado', fechamentoCaixa.totais.totalAdiantamentoLancado)}
                {this.exbirLinhaTotal('(-) Total despesas', fechamentoCaixa.totais.totalDespesas)}
                {this.exbirLinhaTotal('(-) Total Lançamentos a receber', fechamentoCaixa.totais.totalLancamentoAReceber)}
                {this.exbirLinhaTotal('(-) Total de Seguro', fechamentoCaixa.totais.totalTarifaSeguro)}
                {this.exbirLinhaTotal('(-) Total imposto retido', fechamentoCaixa.totais.totalImpostoRetido)}
                {this.exbirLinhaTotal('(-) Total seguro e imposto retido', fechamentoCaixa.totais.totalTarifaSeguroImpostoRetido)}
                {this.exbirLinhaTotal('(+) Total de vendas', fechamentoCaixa.totais.totalVendas)}
              </tbody>
            </table>
          </div>
          <div className="fc-totais-col" style={{ flex: '1 1 280px', overflowX: 'auto' }}>
            <table className="table table-sm table-bordered" style={{ marginBottom: 0 }}>
              <tbody>
                {this.exbirLinhaTotal('(-) Total recebido cartão', fechamentoCaixa.totais.totalRecebidoCartao)}
                {this.exbirLinhaTotal('(-) Total recebido PIX', fechamentoCaixa.totais.totalRecebidoPix)}
                {this.exbirLinhaTotal('(-) Total recebido Link de Pagamento', fechamentoCaixa.totais.totalRecebidoLinkPagamento)}
                {this.exbirLinhaTotal('(-) Total de cancelamentos', fechamentoCaixa.totais.totalCancelamento)}
                {this.exbirLinhaTotal('(+) Total recebido cartão no site', fechamentoCaixa.totais.totalRecebidoCartaoSite)}
                {this.exbirLinhaTotal('(+) Total de residual de cancelamentos', fechamentoCaixa.totais.totalCustoCancelamento)}
                {this.exbirLinhaTotal('(=) Total excesso bagagem', fechamentoCaixa.totais.totalExcessoBagagem)}
                {this.exbirLinhaTotal('(-) Total comissão Reimpressão', fechamentoCaixa.totais.totalReimpressaoRecibo)}
                {this.exbirLinhaTotal('(-) Total comissão Seguro', fechamentoCaixa.totais.totalComissaoSeguro)}
                {this.exbirLinhaTotal('(=) Total comissão de Entrega', fechamentoCaixa.totais.totalComissaoEntrega)}
                {this.exbirLinhaTotal('(-) Total comissão', fechamentoCaixa.totais.totalComissao)}
                {this.exbirLinhaTotal('( Informativo ) Total desconto', fechamentoCaixa.totais.totalDesconto)}
                {this.exbirLinhaTotal('(=) Total Tx de Embaque CEA', fechamentoCaixa.totais.totalTaxaEmbarqueCEA)}
                {this.exbirLinhaTotal('(=) Total do deposito', fechamentoCaixa.totais.totalDeposito)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Detalhamentos */}
        {this.exbibirReservas(['Em aberto', 'Em aberto/Reembolso Solicitado', 'Remarcada'], 'Reservas Abertas/Remarcadas')}
        {this.exbibirEstornos('Seguros Cancelados')}
        {this.exbibirReservas(['Cancelado', 'Cancelado/Reembolso Efetuado', 'Aprovado'], 'Reservas Canceladas/Aprovadas', true)}
        {this.exibirEncomendas()}
        {this.exibirVendasUrbanas()}
        {this.exibirEncomendasAvulsas()}
        {this.exibirComissaoEntrega()}
        {this.exibirBagagens()}
        {this.exibirHistoricos()}

        {/* Assinatura */}
        <div className="fc-assinatura text-center" style={{ marginTop: '48px' }}>
          <p style={{ textDecoration: 'overline', display: 'inline-block', minWidth: '300px' }}>
            Assinatura do Responsável (Por Extenso)
          </p>
        </div>
      </React.Fragment>
    );
  }

  exibirBotoes () {
    return (
      <div className="d-flex justify-content-center flex-wrap gap-2 my-2" id="printPageButton">
        <Link to="/painel-fechamento-caixa">
          <button className="btn btn-sm btn-laranja mx-1">Concluir</button>
        </Link>
        <button
          className="btn btn-sm btn-laranja mx-1"
          onClick={() => this.imprimir()}
        >
          <i className="material-icons mr-1" style={{ fontSize: '16px', verticalAlign: 'middle' }}>print</i>
          Imprimir / Salvar PDF
        </button>
      </div>
    );
  }

  render () {
    if (this.props.fechamentoCaixa) {
      return (
        <React.Fragment>
          <style dangerouslySetInnerHTML={{ __html: PRINT_STYLES }} />
          <div className="grid invoice" style={{ padding: '8px' }}>
            {this.exibirBotoes()}
            <div
              ref={this.componentRef}
              className="grid-body"
              id="cupom-encomenda"
              style={{ fontSize: '14px', fontWeight: 'bold' }}
            >
              <h1 className="fc-titulo text-center mb-3" style={{ fontSize: '1.4rem' }}>
                Fechamento de caixa
              </h1>
              {this.exibir()}
            </div>
            {this.exibirBotoes()}
          </div>
        </React.Fragment>
      );
    }
    return '';
  }
}

export const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
  fechamentoCaixa: state.fechamentoCaixa
});

export default withRouter(connect(mapStateToProps, { buscarFechamentoCaixa })(PainelDetalhamentoFechamentoCaixa));
